<template>
  <PoemHeader v-if="route.meta.requiresPoemHeader" />
  <ShogunHeader v-else />
  <router-view />
  <PoemFooter v-if="route.meta.requiresPoemFooter" />
  <ShogunFooter v-if="route.meta.requiresFooter" />
</template>

<script setup>
import { useRoute } from 'vue-router'
import ShogunFooter from './components/ShogunFooter.vue'
import ShogunHeader from './components/ShogunHeader.vue'
import PoemHeader from './components/PoemHeader.vue'
import PoemFooter from './components/PoemFooter.vue'

const route = useRoute()
</script>

<style>
/* styles here */
</style>
